import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=2b166b7a&scoped=true&"
import script from "./Solution.vue?vue&type=script&lang=js&"
export * from "./Solution.vue?vue&type=script&lang=js&"
import style0 from "./Solution.vue?vue&type=style&index=0&id=2b166b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b166b7a",
  null
  
)

export default component.exports